//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tinyColor from "tinycolor2";
import { has, isEmpty, values, zipObject } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ColorSelector",
  props: {
    colors: {
      type: Array,
      required: true
    },
    preSelectedColors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedColors: {}
    };
  },
  mounted() {
    if (!isEmpty(this.preSelectedColors)) this.loadPreselectedColors();
  },
  methods: {
    handleSelect(color) {
      if (has(this.selectedColors, color)) {
        this.$delete(this.selectedColors, color);
      } else {
        const lowerCaseColor = color.toLowerCase();
        this.$set(this.selectedColors, lowerCaseColor, lowerCaseColor);
      }
      this.$emit("select", values(this.selectedColors));
    },
    isSelected(color) {
      return has(this.selectedColors, color);
    },
    getStyle(color, selected) {
      return {
        backgroundColor: color,
        border: selected ? "1.5px solid #555" : "1px solid #555"
      };
    },
    getCheckMarkColor(color) {
      if (tinyColor(color).isDark()) return "#fff";
      return "#111";
    },
    loadPreselectedColors() {
      this.selectedColors = zipObject(this.preSelectedColors, this.preSelectedColors);
    },
    reset() {
      this.selectedColors = {};
    }
  }
});